import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 32, className = '', ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-70px' }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, label }) => (
  <Reveal className="flex items-center gap-4 mb-10 sm:mb-14">
    <span className="font-accent text-xs tracking-[0.35em] text-gold">{index}</span>
    <span className="h-px flex-1 max-w-16 bg-gradient-to-r from-gold/60 to-transparent" />
    <span className="font-accent text-[11px] tracking-[0.35em] uppercase text-neutral-500">{label}</span>
  </Reveal>
);
